export const colors = {
  "dark-blue-sct": "#27265c",
  "white-sct": "#ffffff",
};
